import styled from 'styled-components';
import {
  CaptionMixin,
  Heading2Mixin,
  Heading4Mixin,
  Heading5Mixin,
} from '@qover/typography';

export const Price = styled.div`
  ${Heading2Mixin};
  text-align: center;

  &.small {
    ${Heading4Mixin};
    text-decoration: line-through solid currentColor;
  }
`;

export const Description = styled.div`
  ${Heading5Mixin};
  font-weight: normal;
  margin-top: 10px;
`;

export const DiscountPrice = styled.div`
  color: ${props => props.theme.colors.primary()};
`;

export const DiscountContainer = styled.div`
  display: flex;
`;

export const InnerContainer = styled.div`
  margin: 40px 0 10px;
  width: 100%;
  padding: 0 20px;

  > * + * {
    margin-top: 12px;
  }

  &.small {
    margin: 20px 0 10px;
  }
`;

export const VariantTitle = styled.span`
  ${CaptionMixin};
  text-transform: uppercase;
  margin: 40px 0 20px;
  letter-spacing: 1px;
  font-weight: bold;
`;
